import { render } from "./SubpayBody.vue?vue&type=template&id=558b2d87&scoped=true"
import script from "./SubpayBody.vue?vue&type=script&lang=js"
export * from "./SubpayBody.vue?vue&type=script&lang=js"

import "./SubpayBody.vue?vue&type=style&index=0&id=558b2d87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558b2d87"]])

export default __exports__